import { AnaColumn } from "../forms-template.service";

export const trasportatori: AnaColumn[] = [
    {
      itemType: "group", colCount: "6", colSpan: "2", data: [
        //{"id":1,"tipo":"P","ragione_sociale":null,"codice_fiscale":null,"partita_iva":null,
        //"indirizzo":null,"numero":null,"frazione":null,"id_comune":null,"cap":null,
        //"codice_istat":null,"telefono":null,"fax":null,"contatto":null,"email":null,
        //"pec":null,"id_categoria":null,"id_zona":null,"note":null}
        { type: 'campo', dataField: "id", dataType: "", caption: "", colVisible: false },
  
  
      ]
    },
    {
      itemType: "group", colCount: "6", colSpan: "2", data: [
        { type: 'campo', dataField: "tipo", dataType: "" },
        { type: 'campo', dataField: "ragione_sociale", dataType: "", width: "20%" },
        { type: 'campo', dataField: "codice_fiscale", dataType: "" },
        { type: 'campo', dataField: "parita_iva", dataType: "" },
        { type: 'campo', dataField: "indirizzo", dataType: "" },
        { type: 'campo', dataField: "numero", dataType: "" },
        { type: 'campo', dataField: "frazione", dataType: "" },
        { type: 'campo', dataField: "id_comune", dataType: "" },
        { type: 'campo', dataField: "cap", dataType: "" },
        { type: 'campo', dataField: "codice_istat", dataType: "" },
        { type: 'campo', dataField: "telefono", dataType: "" },
        { type: 'campo', dataField: "fax", dataType: "" },
        { type: 'campo', dataField: "contatto", dataType: "" },
        { type: 'campo', dataField: "email", dataType: "" },
        { type: 'campo', dataField: "pec", dataType: "" },
        {
          type: 'campo', dataField: "id_zona", dataType: "",
          lookup: {
            dataSource: 'zona', valueExpr: 'id', displayExpr: 'descrizione', colonne: [
              {
                dataField: 'descrizione',
                dataType: '',
                caption: 'Descrizione'
  
              }
            ]
          }
        },
        {
          type: 'campo', dataField: "id_categoria", dataType: "", lookup: {
            dataSource: 'categorie', valueExpr: 'id', displayExpr: 'descrizione', colonne: [
              {
                dataField: 'descrizione',
                dataType: '',
                caption: 'Categoria'
  
              }
            ]
          }
        },
        { type: 'campo', dataField: "note", dataType: "" },
  
  
      ]
    },
  ]